import {
  ControlProps,
  CSSObjectWithLabel,
  OptionProps,
  StylesConfig,
} from 'react-select';

export const optionsSelectStyles: StylesConfig = {
  menu: (styles: CSSObjectWithLabel) => ({ ...styles, zIndex: 2 }),
  container:(styles: CSSObjectWithLabel) => ({
    ...styles,
    display: 'block',
    width: '100%',
    minWidth: '100%',
    padding: 'none'
  }),
  dropdownIndicator: (styles: CSSObjectWithLabel) => ({
    ...styles,
    padding: '0',
    margin: '0',
  }),
  valueContainer: (styles: CSSObjectWithLabel) => ({
    ...styles,
    justifyContent: 'space-between',
    position: 'relative',
    padding: 'none',
    color: '#000'
  }),
  option: (styles: CSSObjectWithLabel, state: OptionProps) => ({
    ...styles,
    backgroundColor: state.isFocused ? 'yellow' : '#FFFFFF', // Alinha ao `background-color: #FFF;`
    color: '#000', // Alinha ao estilo básico do texto
    fontWeight: state.isFocused ? 'bold' : 'normal',
  }),

  placeholder: (styles: CSSObjectWithLabel) => ({
    ...styles,
    color: '#bababa',
    fontFamily: 'Roboto, sans-serif',
    fontSize: '1rem',
  }),

  control: (styles: CSSObjectWithLabel, state: ControlProps) => ({
    ...styles,
    display: 'flex',
    color: '#000', // Texto padrão
    backgroundColor: '#FFF', // Alinha ao `background-color: #FFF;`
    border: `1px solid ${state.isFocused ? '#00A091' : '#000'}`, // Alinha ao `border: 1px solid #000;`
    height: '2rem', // Ajuste de altura semelhante ao input padrão
    minHeight: '2rem',
    boxShadow: 'none', // Remove sombras
    borderRadius: '0', // Remove bordas arredondadas
    padding: 'none',
    justifyContent: 'space-between',
    '&:hover': {
      borderColor: '#000', // Mantém o estilo ao passar o mouse
    },
  }),

  multiValue: (styles: CSSObjectWithLabel) => ({
    ...styles,
    backgroundColor: '#00A091',
    color: '#FFF',
    '&:hover': {
      backgroundColor: '#007065',
    },
  }),

  multiValueLabel: (styles: CSSObjectWithLabel) => ({
    ...styles,
    color: '#FFF',
  }),
};
